// extracted by mini-css-extract-plugin
export default {"productCard":"styles_productCard__OgI75","cardImg":"styles_cardImg__SG+Jn","cardDesc":"styles_cardDesc__w7ctw","countCard":"styles_countCard__37ozg","icon":"styles_icon__Gy5Wz"};